(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/billing-information.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/billing-information.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.actions,
  UPDATE_BILLING_INFORMATION = _svs$ticket_partner$d.UPDATE_BILLING_INFORMATION,
  RECEIVE_COMPANY_DETAILS = _svs$ticket_partner$d.RECEIVE_COMPANY_DETAILS,
  CLEAR_STATE = _svs$ticket_partner$d.CLEAR_STATE;
const _svs$ticket_partner$d2 = svs.ticket_partner.digitalTickets.constants.names,
  REFERENCE = _svs$ticket_partner$d2.REFERENCE,
  ADDRESS = _svs$ticket_partner$d2.ADDRESS,
  ZIP = _svs$ticket_partner$d2.ZIP,
  CITY = _svs$ticket_partner$d2.CITY;
const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const COUNTRYID = svs.ticket_partner.sharedComponents.input.constants.names.COUNTRYID;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input,
  ZipCodeInput = _svs$ticket_partner$s.ZipCodeInput,
  AdressInput = _svs$ticket_partner$s.AdressInput,
  CityInput = _svs$ticket_partner$s.CityInput,
  AcceptTerms = _svs$ticket_partner$s.AcceptTerms,
  CountryDropdown = _svs$ticket_partner$s.CountryDropdown;
const _svs$ticket_partner$d3 = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.components,
  Reference = _svs$ticket_partner$d3.Reference,
  MessageInput = _svs$ticket_partner$d3.MessageInput,
  InvoiceMessageInput = _svs$ticket_partner$d3.InvoiceMessageInput;
const HEADER = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants.TEXTS.HEADER;
const BillingInformation = () => {
  const _useContext = useContext(svs.ticket_partner.DigitalTicketsContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    isLoggedIn = _svs$ticket_partner$u.isLoggedIn,
    companyDetailsPromise = _svs$ticket_partner$u.companyDetailsPromise;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    companyName = _useState2[0],
    setCompanyName = _useState2[1];
  useEffect(() => {
    const fetchData = async () => {
      let stateCleared = false;
      if (isLoggedIn) {
        var _companyDetails$addre;
        svs.ui.loader.show();
        const _await$companyDetails = await companyDetailsPromise,
          companyDetails = _await$companyDetails.companyDetails;
        if (state.partnerId !== companyDetails.partnerId) {
          dispatch({
            type: CLEAR_STATE
          });
          stateCleared = true;
        }
        const billingAdress = (_companyDetails$addre = companyDetails.addresses) === null || _companyDetails$addre === void 0 ? void 0 : _companyDetails$addre.find(_ref => {
          let addressType = _ref.addressType;
          return addressType.toLowerCase() === 'billing';
        });
        setCompanyName(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.companyName);
        if (billingAdress) {
          const contact = billingAdress.contact,
            city = billingAdress.city,
            zip = billingAdress.zip,
            address1 = billingAdress.address1;
          const setValue = (field, resVal) => stateCleared ? resVal : state.billingInformation[field] || resVal || '';
          dispatch({
            type: RECEIVE_COMPANY_DETAILS,
            payload: {
              partnerId: companyDetails.partnerId,
              reference: setValue(REFERENCE, contact),
              address1: setValue(ADDRESS, address1),
              city: setValue(CITY, city),
              zip: setValue(ZIP, zip)
            }
          });
        }
        svs.ui.loader.hide();
      }
    };
    fetchData();
  }, [isLoggedIn, companyDetailsPromise]);
  const handleOnChange = _ref2 => {
    let target = _ref2.target;
    dispatch({
      type: UPDATE_BILLING_INFORMATION,
      payload: {
        field: target.id,
        value: target.value
      }
    });
  };
  const handleOnChangeCheckBox = _ref3 => {
    let target = _ref3.target;
    dispatch({
      type: UPDATE_BILLING_INFORMATION,
      payload: {
        field: target.id,
        value: target.checked
      }
    });
  };
  const handleDropDownChange = e => {
    dispatch({
      type: UPDATE_BILLING_INFORMATION,
      payload: {
        field: COUNTRYID,
        value: parseInt(e.target.value, 10)
      }
    });
  };
  return React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(GridRow, null, React.createElement("h2", null, HEADER), companyName && React.createElement("h3", null, companyName)), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 6,
    sm: 12
  }, React.createElement(Reference, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridCol, {
    am: 6,
    sm: 12
  }, React.createElement(AdressInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  }))), React.createElement(GridRow, null, React.createElement(GridCol, {
    am: 3,
    sm: 12
  }, React.createElement(ZipCodeInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridCol, {
    am: 4,
    sm: 12
  }, React.createElement(CityInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridCol, {
    am: 5,
    sm: 12
  }, React.createElement(CountryDropdown, {
    handleDropDownChange: handleDropDownChange,
    state: state.billingInformation
  }))), React.createElement(GridRow, {
    className: "padding-top-2"
  }, React.createElement(InvoiceMessageInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridRow, {
    className: "padding-top-2"
  }, React.createElement(MessageInput, {
    handleChange: handleOnChange,
    state: state.billingInformation
  })), React.createElement(GridRow, {
    className: "padding-top-1"
  }, React.createElement(AcceptTerms, {
    handleOnChange: handleOnChangeCheckBox,
    state: state.billingInformation
  })));
};
svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.BillingInformation = BillingInformation;

 })(window);